import { render, staticRenderFns } from "./egiftcard.vue?vue&type=template&id=23d015a4"
import script from "./egiftcard.vue?vue&type=script&lang=js"
export * from "./egiftcard.vue?vue&type=script&lang=js"
import style0 from "./egiftcard.vue?vue&type=style&index=0&id=23d015a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports